import { render, staticRenderFns } from "./surplus.vue?vue&type=template&id=3c62fe11&scoped=true&"
import script from "./surplus.vue?vue&type=script&lang=js&"
export * from "./surplus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c62fe11",
  null
  
)

export default component.exports